// components/StopBottomSheet.jsx
import React, { useState, useEffect } from 'react';
import { fetchDepartures } from '../services/api';
import DeparturesList from './DeparturesList';
import FULL_STOP_MAP from '../data/FULL_STOP_MAP.js';
import { useResizableSheet } from '../hooks/useResizableSheet';

function StopBottomSheet({ stopId, stopData, onClose }) {
  const [departures, setDepartures] = useState([]);
  const [loading, setLoading] = useState(true);

  // Logika nazwy
  const getStopName = () => {
    if (!stopData) return 'Przystanek';
    const idStr = stopData.stopId.toString();
    if (FULL_STOP_MAP[idStr]) return FULL_STOP_MAP[idStr];
    if (stopData.subName) return `${stopData.stopDesc} ${stopData.subName}`;
    return stopData.stopDesc;
  };

  useEffect(() => {
    if (!stopId) return;

    const loadData = async () => {
      setLoading(true);
      try {
        const data = await fetchDepartures(stopId);
        setDepartures(data || []);
      } catch (err) {
        console.error(err);
        setDepartures([]);
      } finally {
        setLoading(false);
      }
    };

    loadData();
    const interval = setInterval(loadData, 30000);
    return () => clearInterval(interval);
  }, [stopId]);

  const isActive = !!stopId;

  const { handleRef, sheetStyle, resetHeight } = useResizableSheet(onClose, 1, [35, 75, 85]);

  useEffect(() => {
    if (stopId) resetHeight();
  }, [stopId, resetHeight]);

  return (
    <div
      className={`bottom-sheet-container ${isActive ? 'active' : ''}`}
      style={sheetStyle}
    >
      <div className="sheet-handle-bar" ref={handleRef} onClick={onClose}>
        <div className="sheet-handle"></div>
      </div>

      <div className="sheet-header">
        <div className="sheet-title">
          <h2>{getStopName()}</h2>
          <p>Kod przystanku: {stopId}</p>
        </div>
        <button className="close-btn" onClick={onClose} aria-label="Zamknij panel">
          &times;
        </button>
      </div>

      <div className="sheet-content">
        {loading ? (
          <div className="loading">Ładowanie odjazdów...</div>
        ) : (
          <DeparturesList departures={departures} />
        )}
      </div>
    </div>
  );
}

export default StopBottomSheet;